import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSettings, getProducts, getBundle } from "@/lib/api";
import { CheckoutDialog } from "@/components/CheckoutDialog";
import { EmailPopup } from "@/components/EmailPopup";

const StoreContext = createContext(null);
export const useStore = () => useContext(StoreContext);

export const StoreProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [products, setProducts] = useState([]);
  const [bundle, setBundle] = useState(null);
  const [checkoutItem, setCheckoutItem] = useState(null);
  const [initialCode, setInitialCode] = useState("");
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    getSettings().then(setSettings).catch(() => {});
    getProducts().then(setProducts).catch(() => {});
    getBundle().then(setBundle).catch(() => {});
  }, []);

  const openCheckout = (item, code = "") => {
    setInitialCode(code || localStorage.getItem("um_code") || "");
    setCheckoutItem(item);
  };
  const closeCheckout = () => setCheckoutItem(null);

  return (
    <StoreContext.Provider value={{ settings, products, bundle, openCheckout }}>
      {children}
      <CheckoutDialog item={checkoutItem} onClose={closeCheckout} initialCode={initialCode} />
      {!isAdmin && <EmailPopup onCode={(code) => localStorage.setItem("um_code", code)} />}
    </StoreContext.Provider>
  );
};
